<div #chart class="chart apexchart"></div>
<loading *ngIf="loading"></loading>